import React from "react";
import "./WhatsappFloat.scss";

const WhatsappFloat = () => {
  return (
    <a
      href="https://wa.me/525564426524?text=Me%20interesa%20planear%20mis%2015%20años"
      target="_blank"
      rel="noreferrer"
      className="whatsappFloat"
      aria-label="WhatsApp Dreams XV"
    >
      <span className="whatsappFloat__icon">💬</span>
      <span className="whatsappFloat__text">
        Planear mis XV
      </span>
    </a>
  );
};

export default WhatsappFloat;